// extracted by mini-css-extract-plugin
export default {"cont":"NoDataDashboar_cont__wAUJA","whiteCont":"NoDataDashboar_whiteCont__17ZW1"};